import styled from "styled-components";
import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { SET_MODAL } from "@/store/slices/appSlice";
import { useDispatch } from "react-redux";
import themes from "@/styles/themes";

const Block = styled.div`
  background: white;
  text-align: left;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  overflow-y: scroll;
  width: 80vw;
  height: 80%;
  position: relative;
  p.sublinhado {
    text-decoration: underline;
  }
`
const HeaderModalSummary = styled.header`
display:flex;
justify-content: space-between;
width: 100%;
border-bottom: 2px solid #BFB2AC;
background-color: white;
z-index:1;
position: sticky;
padding: 0 8px;
top:0;
h1{
 color: black;
}
`
const ContentArea = styled.div`
  width:80%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  line-height: 1.2;
  margin: 0 auto;
  h4{
    font-weight: 700;
    text-align: center;
  }

}
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${themes.grey};
  cursor: pointer;
  right: 12px;
  top: 12px;

  svg {
    width: 14px;
    height: 14px;
  }
`

export default function SumarioDoContrato() {
    const dispatch = useDispatch();

    return (
        <Block>
            <HeaderModalSummary>
                <h1>Sumário do Contrato</h1>
                <CloseButton onClick={() => {
                    dispatch(SET_MODAL({ type: null, show: false }))
                }}><Icon path={mdiClose} size={1}></Icon></CloseButton>
            </HeaderModalSummary>
            <ContentArea>
                <h4 className="subtitle">SUMÁRIO DAS CONDIÇÕES GERAIS DE CONTRATAÇÃO DE ASSINATURAS – ESTADÃO</h4>
                <h4>SUMÁRIO DO CONTRATO PARA CONTRATAÇÃO DE ASSINATURA DA VERSÃO IMPRESSA DO JORNAL “O ESTADO DE S.PAULO”</h4>


                <p>
                    A Assinatura somente poderá ser paga por meio de cartão de crédito ou débito em conta corrente;
                </p>


                <p>
                    O débito da Assinatura será efetuado no primeiro dia útil seguinte à data de contratação da assinatura,
                    a depender da forma de pagamento escolhida pelo Assinante;
                </p>


                <p className="sublinhado">
                    O VALOR DA ASSINATURA PODERÁ SER REAJUSTADO OU ALTERADO PELO ESTADÃO, QUE
                    DEVERÁ INFORMAR AO ASSINANTE A ALTERAÇÃO DO VALOR.
                </p>


                <p className="sublinhado">
                    CASO O ATRASO NO PAGAMENTO DA ASSINATURA SEJA SUPERIOR A 15 (QUINZE) DIAS, A
                    REFERIDA ASSINATURA PODERÁ SER SUSPENSA ATÉ O ADIMPLEMENTO DAS OBRIGAÇÕES
                    EM ATRASO, SENDO FACULTADO À OESP, AINDA, CONSIDERAR RESCINDIDO O CONTRATO
                    POR JUSTO MOTIVO;
                </p>


                <p>
                    A primeira entrega do exemplar do Jornal “O Estado de S. Paulo” ocorrerá dentro de um prazo de até
                    07 (sete) dias úteis contados da efetivação da Assinatura;
                </p>


                <p className="sublinhado">
                    O ASSINANTE DEVERÁ INFORMAR, NO MOMENTO DA CONTRATAÇÃO DA ASSINATURA, OS
                    DADOS PARA ENTREGA DOS EXEMPLARES IMPRESSOS DO JORNAL “O ESTADO DE S.
                    PAULO”, NÃO SE RESPONSABILIZANDO O ESTADÃO POR EVENTUAIS INCORREÇÕES DE
                    DADOS DE ENTREGA FORNECIDOS PELO ASSINANTE;
                </p>


                <p className="sublinhado">
                    FICA DESDE JÁ ESTABELECIDO QUE A EFETIVAÇÃO DA ASSINATURA SERÁ ANALISADA
                    PELO ESTADÃO E, CASO O ESTADÃO NÃO REALIZE A DISTRIBUIÇÃO DO JORNAL “O
                    ESTADO DE S. PAULO”, NA REGIÃO DE ENTREGA SOLICITADA PELO ASSINANTE, O
                    ASSINANTE SERÁ COMUNICADO DA NÃO EFETIVAÇÃO DA ASSINATURA;
                </p>


                <p className="sublinhado">
                    NÃO CARACTERIZA INADIMPLEMENTO CONTRATUAL POR PARTE DO ESTADÃO, A NÃO
                    ENTREGA DE EXEMPLARES IMPRESSOS DO JORNAL “O ESTADO DE S. PAULO”, EM
                    DECORRÊNCIA DE CASO FORTUITO OU FORÇA MAIOR, BEM COMO NA HIPÓTESE DE
                    INCORREÇÕES NOS DADOS FORNECIDOS PELO ASSINANTE, PARA ENTREGA DOS
                    EXEMPLARES IMPRESSOS DO JORNAL “O ESTADO DE S. PAULO”;
                </p>


                <p>
                    Em caso de alteração de endereço para entrega, o ESTADÃO deverá ser comunicado imediatamente,
                    através do Meu Estadão (https://meu.estadao.com.br) ou dos telefones 4003-5323 (Capitais e Regiões
                    Metropolitanas) e 0800-014-7720 (Demais Localidades e para ligações realizadas de telefone fixo), de
                    segunda à sexta feira das 6h30min as 18h00min e sábados domingos e feriados, das 6h30min às
                    13h00min, sendo facultado à OESP rescindir o Contrato, caso o ESTADÃO não realize a distribuição
                    do jornal “O Estado de S.Paulo” no novo endereço informado pelo Assinante;
                </p>


                <p className="sublinhado">
                    CASO OCORRA A DESCONTINUIDADE DA ENTREGA DO JORNAL “O ESTADO DE S. PAULO”
                    NO ENDEREÇO DO ASSINANTE, A ASSINATURA SERÁ, AUTOMATICAMENTE, CANCELADA,
                    SEM QUE QUAISQUER MULTAS E/OU INDENIZAÇÕES, DE QUALQUER NATUREZA, SEJAM
                    IMPUTADOS AO ESTADÃO. NA HIPÓTESE SUPRAMENCIONADA, CASO O PAGAMENTO DA
                    ASSINATURA TENHA SIDO REALIZADO À VISTA, O ESTADÃO SE COMPROMETE A DEVOLVER
                    O VALOR PAGO PELO ASSINANTE, DE FORMA PROPORCIONAL;
                </p>


                <p className="sublinhado">
                    TODOS OS DADOS PESSOAIS COLETADOS DO ASSINANTE SERÃO INCORPORADOS DE
                    FORMA DEFINITIVA A BASE DE DADOS DA S.A.&quot;O ESTADO DE S. PAULO&quot;, SITUADA NA AV.
                    ENGENHEIRO CAETANO ÁLVARES, 55, SÃO PAULO - SP, CNPJ Nº. 61.533.949/0001-41. . O
                    TRATAMENTO DOS DADOS PESSOAIS COLETADOS SE DARÁ CONFORME A POLÍTICA DE
                    PRIVACIDADE DA S.A. “O ESTADO DE S. PAULO”, DISPONÍVEL EM:
                    https://www.estadao.com.br/termo-de-uso#politica-privacidade
                </p>


                <p className="sublinhado">
                    O ESTADÃO, A QUALQUER TEMPO, PODERÁ ALTERAR O NOME E/OU AS MODALIDADES DE
                    ASSINATURAS OFERTADAS AOS ASSINANTES;
                </p>


                <p>
                    O Estadão poderá oferecer benefícios extras (gratuitos ou pagos) atrelados à assinatura, mas reserva
                    se o direito de descontinuá-los a qualquer momento, mediante aviso ao Assinante.
                </p>


                <p>
                    Dependendo da modalidade de Assinatura contratada, o Assinante pode compartilhar a assinatura com
                    convidados (&quot;Membros&quot;) e acessar o conteúdo em múltiplos dispositivos simultaneamente, respeitando
                    os limites da oferta. O Assinante é o único responsável por gerenciar esses acessos (inclusão via &quot;Meu
                    Estadão&quot;), garantir que os Membros realizem seus cadastros próprios e cumpram as regras de uso. O
                    Estadão reserva-se o direito de bloquear ou cancelar a Assinatura caso identifique uso indevido, ou
                    cortar o acesso dos Membros caso o plano do titular seja alterado ou suspenso.
                </p>


                <p>
                    A Assinatura poderá ser cancelada pelo Assinante, mediante notificação, através do
                    site https://meu.estadao.com.br/fale-conosco ou dos telefones 4003-5323 (Capitais e Regiões
                    Metropolitanas) e 0800-014-7720 (Demais Localidades e apenas ligações realizadas de telefone fixo)
                    de segunda à sexta feira das 8h00min as 18h00min, exceto em feriados locais e nacionais;
                </p>


                <p>
                    Caso o pagamento da Assinatura tenha sido realizado à vista, o ESTADÃO se compromete a devolver
                    o valor pago pelo Assinante, de forma proporcional, exceto se houver a ocorrência de inadimplemento
                    contratual pelo Assinante ou em casos de ofertas promocionais por prazo determinado;
                </p>


                <p>
                    Para eventuais dúvidas e/ou solicitações sobre as assinaturas dos Itens Estadão, com exceção do
                    pedido de cancelamento da Assinatura, o Assinante poderá contatar o ESTADÃO, através do Meu
                    Estadão (https://meu.estadao.com.br) ou dos telefones 4003-5323 (Capitais e Regiões Metropolitanas)
                    e 0800-014-7720 (Demais Localidades e para ligações realizadas de telefone fixo), de segunda à sexta
                    feira das 6h30min as 18h00min e sábados domingos e feriados, das 6h30min às 13h00min; e
                </p>


                <p>
                    O contrato será regido e interpretado de acordo com a legislação brasileira, sendo eleito o Foro da
                    Comarca de São Paulo, Estado de São Paulo, para questões a ele relativas, com renúncia expressa a
                    qualquer outro.
                </p>


                <h4>
                    SUMÁRIO DO CONTRATO PARA CONTRATAÇÃO DE ASSINATURA DA VERSÃO DIGITAL DO
                    JORNAL “O ESTADO DE S.PAULO” E/OU DO PORTAL ESTADAO.COM.BR
                </h4>


                <p>
                    A Assinatura somente poderá ser paga por meio de cartão de crédito ou débito em conta corrente;
                </p>


                <p>
                    O débito da Assinatura será efetuado no primeiro dia útil seguinte à data de contratação da assinatura,
                    a depender da forma de pagamento escolhida pelo Assinante;
                </p>


                <p className="sublinhado">
                    O VALOR DA ASSINATURA PODERÁ SER REAJUSTADO OU ALTERADO PELO ESTADÃO, QUE
                    DEVERÁ INFORMAR AO ASSINANTE A ALTERAÇÃO DO VALOR.
                </p>


                <p className="sublinhado">
                    CASO O ATRASO NO PAGAMENTO DA ASSINATURA SEJA SUPERIOR A 15 (QUINZE) DIAS, A
                    REFERIDA ASSINATURA PODERÁ SER SUSPENSA ATÉ O ADIMPLEMENTO DAS OBRIGAÇÕES
                    EM ATRASO, SENDO FACULTADO AO ESTADÃO, AINDA, CONSIDERAR RESCINDIDO O
                    CONTRATO POR JUSTO MOTIVO;
                </p>


                <p>
                    O Assinante receberá, no momento da contratação da Assinatura, um login e uma senha para ter
                    acesso aos conteúdos disponibilizados pelo ESTADÃO, de acordo com a modalidade de Assinatura
                    contratada pelo Assinante;
                </p>


                <p className="sublinhado">
                    O ASSINANTE SERÁ RESPONSÁVEL PELA GUARDA E CONFIDENCIALIDADE DE SEU LOGIN E
                    SENHA DE ACESSO AOS CONTEÚDOS DISPONIBILIZADOS PELO ESTADÃO, DEVENDO
                    TOMAR TODAS AS PRECAUÇÕES NECESSÁRIAS PARA IMPEDIR O USO DE SUA SENHA POR
                    TERCEIROS, SOB PENA DE IMEDIATA RESCISÃO DO CONTRATO;
                </p>


                <p>
                    Os conteúdos são disponibilizados sem cessão definitiva (licenciamento) ao Assinante para uso
                    próprio. <b>FICA EXPRESSAMENTE VEDADO AO ASSINANTE:</b> (i) qualquer tipo de distribuição ou
                    redistribuição direta (terceiros) ou indireta (internet/intranet/extranet/telão e outros meios que existam
                    ou que possam vir a existir) dos conteúdos e informações contidos no Jornal “O Estado de S.Paulo”, no
                    Portal estadao.com.br e/ou em qualquer outro item de titularidade do ESTADÃO que o Assinante venha
                    a ter acesso (“Conteúdos Estadão”); (ii) reprodução, veiculação e/ou divulgação dos Conteúdos
                    Estadão; (iii) comercialização, cessão e/ou licenciamento dos Conteúdos Estadão; (iv) armazenamento
                    dos Conteúdos Estadão; (v) utilização dos Conteúdos Estadão, como fonte de informação para
                    elaboração de clipping de notícias ou qualquer outro tipo de informativo ou documento, sob pena de
                    cancelamento da Assinatura e indenização pelos danos causados;
                </p>


                <p>
                    O Assinante declara-se ciente de que os Conteúdos Estadão constituem-se propriedade exclusiva do
                    ESTADÃO e de seus fornecedores, consoante as normas de propriedade intelectual e direitos autorais;
                </p>


                <p className="sublinhado">
                    O ESTADÃO PODERÁ ALTERAR, A SEU CRITÉRIO, AS CARACTERÍSTICAS, APRESENTAÇÃO
                    OU QUALQUER ASPECTO DOS CONTEÚDOS ESTADÃO, ACRESCENTANDO OU SUPRIMINDO
                    INFORMAÇÕES, COM O QUE DESDE JÁ CONCORDA O ASSINANTE;
                </p>


                <p className="sublinhado">
                    ALÉM DO EXPOSTO ACIMA, O ESTADÃO, A QUALQUER TEMPO, PODERÁ EXCLUIR E/OU
                    ALTERAR O ACESSO A DETERMINADOS CONTEÚDOS ESTADÃO QUE A ASSINATURA
                    PERMITA O ACESSO;
                </p>


                <p className="sublinhado">
                    EM NENHUMA HIPÓTESE O ESTADÃO OU SEUS FORNECEDORES PODERÃO SER
                    RESPONSABILIZADOS POR QUAISQUER PERDAS E DANOS (INCLUINDO, MAS NÃO
                    LIMITADOS, AOS LUCROS CESSANTES, INTERRUPÇÃO DE NEGÓCIOS, PERDAS DE
                    INFORMAÇÕES E OUTROS PREJUÍZOS PECUNIÁRIOS, DE QUALQUER NATUREZA)
                    RESULTANTES DO USO OU DA IMPOSSIBILIDADE DE USO DOS CONTEÚDOS ESTADÃO;
                </p>


                <p className="sublinhado">
                    O ASSINANTE RECONHECE E ACEITA QUE A ISENÇÃO DE RESPONSABILIDADE DO ESTADÃO
                    E DE SEUS FORNECEDORES PREVISTA NO ITEM ACIMA, CONSTITUI FATOR DETERMINANTE
                    PARA A DISPONIBILIZAÇÃO DOS CONTEÚDOS ESTADÃO, BEM COMO TAL HIPÓTESE FOI
                    DEVIDAMENTE CONSIDERADA NA FIXAÇÃO DO PREÇO DA ASSINATURA;
                </p>


                <p className="sublinhado">
                    O ESTADÃO NÃO TERÁ QUALQUER RESPONSABILIDADE POR PROBLEMAS OCORRIDOS NO
                    ACESSO AOS CONTEÚDOS ESTADÃO, EM DECORRÊNCIA DE EVENTOS QUE SE
                    CARACTERIZEM COMO CASO FORTUITO OU FORÇA MAIOR, ASSIM ENTENDIDAS AS
                    CIRCUNSTÂNCIAS IMPREVISÍVEIS E INEVITÁVEIS QUE IMPEÇAM, TOTAL OU PARCIALMENTE,
                    A EXECUÇÃO DAS OBRIGAÇÕES ORA ASSUMIDAS, E/OU QUE DEPENDAM DE SERVIÇOS DE
                    RESPONSABILIDADE DE TERCEIROS E/OU DA ADMINISTRAÇÃO PÚBLICA, DIRETA OU
                    INDIRETA;
                </p>


                <p className="sublinhado">
                    O ESTADÃO NÃO RESPONDE POR QUAISQUER DANOS OU PREJUÍZOS DECORRENTES
                    VÍRUS, SPAMS, WORMS, DEFEITOS, CAVALOS DE TRÓIA, ARQUIVOS CORROMPIDOS,
                    FALSIFICAÇÕES OU QUAISQUER ITENS DE NATUREZA DESTRUTIVA OU ENGANOSA OU
                    OUTROS ELEMENTOS FÍSICOS OU ELETRÔNICOS QUE POSSAM DANIFICAR OU IMPEDIR O
                    NORMAL FUNCIONAMENTO E ACESSO AOS CONTEÚDOS ESTADÃO, BEM COMO NA REDE,
                    SISTEMA OU DOS EQUIPAMENTOS (HARDWARE E SOFTWARE) DOS ASSINANTES;
                </p>


                <p className="sublinhado">
                    TODOS OS DADOS PESSOAIS COLETADOS DO ASSINANTE SERÃO INCORPORADOS DE
                    FORMA DEFINITIVA A BASE DE DADOS DA S.A.&quot;O ESTADO DE S. PAULO&quot;, SITUADA NA AV.
                    ENGENHEIRO CAETANO ÁLVARES, 55, SÃO PAULO - SP, CNPJ Nº. 61.533.949/0001-41. . O
                    TRATAMENTO DOS DADOS PESSOAIS COLETADOS SE DARÁ CONFORME A POLÍTICA DE
                    PRIVACIDADE DA S.A. “O ESTADO DE S. PAULO”, DISPONÍVEL EM:
                    https://www.estadao.com.br/termo-de-uso#politica-privacidade
                </p>


                <p className="sublinhado">
                    O ESTADÃO, A QUALQUER TEMPO, PODERÁ ALTERAR O NOME E/OU AS MODALIDADES DE
                    ASSINATURAS OFERTADAS AOS ASSINANTES;
                </p>


                <p>
                    O Estadão poderá oferecer benefícios extras (gratuitos ou pagos) atrelados à assinatura, mas reserva
                    se o direito de descontinuá-los a qualquer momento, mediante aviso ao Assinante.
                </p>


                <p>
                    Dependendo da modalidade de Assinatura contratada, o Assinante pode compartilhar a assinatura com
                    convidados (&quot;Membros&quot;) e acessar o conteúdo em múltiplos dispositivos simultaneamente, respeitando
                    os limites da oferta. O Assinante é o único responsável por gerenciar esses acessos (inclusão via &quot;Meu
                    Estadão&quot;), garantir que os Membros realizem seus cadastros próprios e cumpram as regras de uso. O
                    Estadão reserva-se o direito de bloquear ou cancelar a Assinatura caso identifique uso indevido, ou
                    cortar o acesso dos Membros caso o plano do titular seja alterado ou suspenso.
                </p>


                <p>
                    O Assinante reconhece que o acesso ao Portal estadao.com.br e/ou Acervo Estadão está condicionado
                    ao cumprimento de seus Termos Uso disponíveis em: https://www.estadao.com.br/termo-de-uso#;
                </p>


                <p>
                    A Assinatura poderá ser cancelada pelo Assinante, mediante notificação, através do
                    site https://meu.estadao.com.br/fale-conosco ou dos telefones 4003-5323 (Capitais e Regiões
                    Metropolitanas) e 0800-014-7720 (Demais Localidades e apenas ligações realizadas de telefone fixo)
                    de segunda à sexta feira das 8h00min as 18h00min, exceto em feriados locais e nacionais;
                </p>


                <p>
                    Caso o pagamento da Assinatura tenha sido realizado à vista, o ESTADÃO se compromete a devolver
                    o valor pago pelo Assinante, de forma proporcional, exceto se houver a ocorrência de inadimplemento
                    contratual pelo Assinante ou em casos de ofertas promocionais por prazo determinado;
                </p>

                <p>
                    Para eventuais dúvidas e/ou solicitações sobre as assinaturas dos Itens Estadão, com exceção do
                    pedido de cancelamento da Assinatura, o Assinante poderá contatar o ESTADÃO, através do Meu
                    Estadão (https://meu.estadao.com.br) ou dos telefones 4003-5323 (Capitais e Regiões Metropolitanas)
                    e 0800-014-7720 (Demais Localidades e para ligações realizadas de telefone fixo), de segunda à sexta
                    feira das 6h30min as 18h00min e sábados domingos e feriados, das 6h30min às 13h00min; e
                </p>

                <p>
                    O contrato será regido e interpretado de acordo com a legislação brasileira, sendo eleito o Foro da
                    Comarca de São Paulo, Estado de São Paulo, para questões a ele relativas, com renúncia expressa a
                    qualquer outro.
                </p>
            </ContentArea>
        </Block>
    )
}